<section class="platform-address-book">
  <mat-tab-group animationDuration="180ms" preserveContent [(selectedIndex)]="activeTabIndex">
    <mat-tab label="Kontakte">
      <app-con-x-table-page
        eyebrow="Platform Admin"
        eyebrowIcon="contacts"
        [title]="contactTitle"
        [description]="contactDescription"
        ariaLabel="Alle Kontakte der Plattform"
        locale="de-DE"
        [data]="visibleEntries"
        [columns]="entryColumns"
        [actions]="contactActions"
        [filters]="entryFilters"
        [inspector]="entryInspector"
        [selectedRow]="selectedEntry"
        [rowId]="'addressBookEntryId'"
        [summaryItems]="entrySummaryItems"
        [emptyState]="entryEmptyState"
        [loading]="loading"
        loadingMessage="Plattformweite Kontakte werden geladen …"
        [errorMessage]="errorMessage"
        errorTitle="Kontakte konnten nicht geladen werden"
        searchPlaceholder="Kontakt, Adressbuch oder Bereich suchen"
        noResultsTitle="Keine passenden Kontakte"
        noResultsDescription="Ändern Sie den Suchbegriff oder die Filter."
        [refreshable]="true"
        refreshTooltip="Plattformweites Adressbuch aktualisieren"
        (pageAction)="handleContactPageAction($event)"
        (selectedRowChange)="selectedEntry = $event"
        (refreshRequested)="refresh()"
        (retryRequested)="refresh()">
      </app-con-x-table-page>
    </mat-tab>

    <mat-tab label="Adressbücher">
      <app-con-x-table-page
        eyebrow="Platform Admin"
        eyebrowIcon="menu_book"
        title="Adressbücher der Plattform"
        description="Alle persönlichen und organisationsbezogenen Adressbücher im Überblick."
        ariaLabel="Alle Adressbücher der Plattform"
        locale="de-DE"
        [data]="addressBooks"
        [columns]="addressBookColumns"
        [filters]="addressBookFilters"
        [selectableRows]="true"
        [selectedRow]="selectedAddressBook"
        [rowId]="'addressBookId'"
        [summaryItems]="addressBookSummaryItems"
        [emptyState]="addressBookEmptyState"
        [loading]="loading"
        loadingMessage="Plattformweite Adressbücher werden geladen …"
        [errorMessage]="errorMessage"
        errorTitle="Adressbücher konnten nicht geladen werden"
        searchPlaceholder="Adressbuch oder Bereich suchen"
        noResultsTitle="Kein passendes Adressbuch"
        noResultsDescription="Ändern Sie den Suchbegriff oder den Filter."
        [refreshable]="true"
        refreshTooltip="Adressbücher aktualisieren"
        (selectedRowChange)="openAddressBook($event)"
        (refreshRequested)="refresh()"
        (retryRequested)="refresh()">
      </app-con-x-table-page>
    </mat-tab>
  </mat-tab-group>
</section>
